export enum DiffType {
  ADDED = 'added',
  DELETED = 'deleted',
}

type EnhancedFilterItemT = {
  type: DiffType;
};

export type EnhancedFilterItemTextT = {
  text: string;
} & EnhancedFilterItemT;

export type EnhancedFilterItemEmailT = {
  email: string;
} & EnhancedFilterItemT;

export type EnhancedFilterItemEmailDomainT = {
  emailDomain: string;
} & EnhancedFilterItemT;
